<template>
  <el-carousel
      :loop="loop"
      :arrow="arrow"
      :autoplay="autoplay"
      indicator-position="none"
      ref="cardShow"
      :class="carouselClass"
  >
    <el-carousel-item :class="carouselItemClass" v-for="(itemList, index) in carouselItemList" :key="index">
      <div class="image-container" :class="imageClass" v-for="item in itemList" :key="item.id" v-if="defaultTheme" @click="itemClick(item)">
        <cms-image :src="item.cover" class="image scale" radius></cms-image>
        <div class="image-title" v-if="imageTitleKey !== ''">{{ item[imageTitleKey] }}</div>
      </div>
      <slot :items="itemList"></slot>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import './less/carouse-flexible.css'
export default {
  name: 'CarouselFlexible',
  props: {
    height: {
      type: Number,
      default: 1.666 * 192 * document.documentElement.clientWidth / 1920
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    arrow: {
      type: String,
      default: 'never'
    },
    loop: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    flexNumber: {
      type: Number,
      default: 3
    },
    carouselClass: {
      type: String,
      default: 'el-carousel'
    },
    carouselItemClass: {
      type: String,
      default: 'el-car-item'
    },
    imageClass: {
      type: String,
      default: 'top-img'
    },
    imageTitleKey: {
      type: String,
      default: ''
    },
    /**
     * 使用使用默认的主题，默认true。 false时需要自定义插槽
     */
    defaultTheme: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      carouselItemList: []
    }
  },
  watch: {
    list: {
      handler(array) {
        this.initialize(array);
      },
      immediate: true
    }
  },
  methods: {
    initialize(array) {
      array.forEach((item, index) => {
        if (index % this.flexNumber === 0) {
          this.carouselItemList.push([item]);
        } else {
          this.carouselItemList[this.carouselItemList.length - 1].push(item);
        }
      });
    },
    next() {
      this.$refs.cardShow.next()
    },
    prev() {
      this.$refs.cardShow.prev()
    },
    itemClick(item) {
      this.$emit('item-click', item);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CarouselFlexible.vue